import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for Capacitor apps
 */

export const isNative = () => Capacitor.isNativePlatform();
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isWeb = () => Capacitor.getPlatform() === 'web';

export const getPlatform = () => Capacitor.getPlatform();

/**
 * Check if we should use native behaviors vs web behaviors
 */
export const useNativeBehavior = () => isNative();

/**
 * Detect if user is on iOS mobile (either native app or mobile browser)
 */
export const isIOSMobile = () => {
  // Check if running in native iOS app
  if (Capacitor.getPlatform() === 'ios') {
    return true;
  }
  
  // Check user agent for iOS mobile browsers
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

/**
 * True for iPad (Safari / WebView), including iPadOS “Request Desktop Website”
 * which reports as MacIntel + touch points.
 */
export const isIPad = () => {
  if (typeof window === 'undefined') return false;
  if (/iPad/.test(navigator.userAgent)) return true;
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  return false;
};


